import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=c20cf212&scoped=true&"
import script from "./BackToTop.vue?vue&type=script&lang=ts&"
export * from "./BackToTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20cf212",
  null
  
)

export default component.exports